import React, { Component } from "react";

// @ts-ignore
import cn from "classnames";
import Alert from "../../../components/Alert";
import Throbber from "../../../components/Throbber";
import Markdown from "../../../components/Markdown";
import WorkflowStepAlert from "./WorkflowStepAlert";
import WorkflowActions from "./WorkflowActions";
import stepShouldSwitchAutomatically from "../../../../redux/modules/workflow/stepShouldSwitchAutomatically";
import {
  workflowStepCN,
  workflowStepRunningCN,
  workflowStepRunningIdLabelCN,
  workflowStepBottomAlertCN,
  workflowStepContentCN,
  workflowStepIdLabelCN,
  workflowStepContentTitleCN,
  workflowStepContentDescriptionCN,
} from "./styles";

import type {
  WorkflowStep,
  WorkflowAction,
} from "../../../../redux/modules/workflow/reducer";

type WorkflowStepRunningProps = {
  step: WorkflowStep;
  onSubmit: (actions: WorkflowAction[]) => void;
};
export default class WorkflowStepRunning extends Component<WorkflowStepRunningProps> {
  render() {
    const { id, title, descriptionMd, pending } = this.props.step;
    const { onSubmit } = this.props;

    return (
      <div
        className={cn(workflowStepCN, workflowStepRunningCN)}
        id={`workflow-step-${id}`}
      >
        <div
          className={cn(workflowStepRunningIdLabelCN, workflowStepIdLabelCN)}
        >
          {pending ? <Throbber /> : id}
        </div>
        <div className={workflowStepContentCN}>
          <div className={workflowStepContentTitleCN}>{title}</div>
          <div className={workflowStepContentDescriptionCN}>
            <Markdown text={descriptionMd} />
          </div>
          {this.renderStepError()}
          <WorkflowActions step={this.props.step} onSubmit={onSubmit} />
        </div>
        {this.renderBottomAlert()}
      </div>
    );
  }

  renderStepError() {
    const { error } = this.props.step;
    if (!error) {
      return null;
    }
    return <Alert>{error}</Alert>;
  }

  renderBottomAlert() {
    // TODO: hack to stop showing a yellow message that step should be switched automatically. Until we have it in the new brand pilot app.
    if (!stepShouldSwitchAutomatically(this.props.step)) {
      return null;
    }

    return (
      <div className={workflowStepBottomAlertCN}>
        <WorkflowStepAlert
          header={"Do not close the browser until the upload is complete"}
          message={"You will be automatically directed to the next step."}
        />
      </div>
    );
  }
}
